import Icon from 'components/Shared/Icon'

import './DeepLinking.scss'

const DeepLinkingNA: React.FC = () => {
  return (
    <div className="deep-linking-unavailable">
      <div className="deep-linking-unavailable__icon">
        <Icon type="link" />
      </div>
      <div className="deep-linking-unavailable__content">
        <h3 className="deep-linking-unavailable__title">
          Deep Linking Not Available
        </h3>
        <p className="deep-linking-unavailable__description">
          Deep linking is not available for legacy apps. Please upgrade your app
          to access this feature.
        </p>
      </div>
    </div>
  )
}

export default DeepLinkingNA
